import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import type { ProductViewProps } from '@/features/storefront/layouts/product/types';
import { PartRegion } from '@/features/storefront/parts/PartRegion';

/**
 * A pet-shop product page: the pack on its oat tile a little wider than the
 * buy column, which sticks beside it on a wide screen - the nearest the
 * storefront comes to the reference's pinned add-to-cart bar. The breadcrumb
 * above and the related products below are drawn by the page itself at its
 * own width.
 */
export const Product: FC<ProductViewProps> = () => (
  <StorefrontContainer className="grid gap-10 py-8 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] lg:gap-14">
    <PartRegion name="gallery" className="min-w-0" />
    <PartRegion name="main" className="min-w-0 lg:sticky lg:top-28 lg:self-start" />
  </StorefrontContainer>
);
